import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  visibility: BehaviorSubject<boolean>;
  spinner$ :any;

  constructor() {
    this.visibility = new BehaviorSubject(false);
    this.spinner$ = this.visibility.asObservable();
  }

  show() {
    this.visibility.next(true);
  }

  hide() {
    this.visibility.next(false);
  }
}
